interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'full' | 'icon';
  className?: string;
}

export default function Logo({ size = 'md', variant = 'full', className = '' }: LogoProps) {
  const iconSizes = {
    sm: 'h-8',
    md: 'h-10',
    lg: 'h-14',
    xl: 'h-20',
  };

  const fullSizes = {
    sm: 'h-8',
    md: 'h-10',
    lg: 'h-14',
    xl: 'h-20',
  };

  if (variant === 'icon') {
    return (
      <img
        src="/logo-icon.png"
        alt="Smart Shopping IL"
        className={`${iconSizes[size]} w-auto object-contain ${className}`}
      />
    );
  }

  return (
    <img
      src="/logo-horizontal.png"
      alt="Smart Shopping IL"
      className={`${fullSizes[size]} w-auto object-contain ${className}`}
    />
  );
}
